export const showWebIcon = (type: string): boolean => {
  return type !== "search";
};
